import { omit } from "lodash";
import { IPackageProps } from "./packages-dto";

export enum RepositoryType {
    ALM = 'ALM',
    CLIENT = 'CLIENT',
    DPU = 'DPU',
    SCR = 'SCR',
    VAR = 'VAR',
    VOS = 'VOS'
}
export const FILTER_REPOSITORY_TYPE = omit(RepositoryType, ['DPU']);

export class RepositoryDto {
    constructor(private readonly _object: unknown) { }

    get uuid(): string {
        return this._object['uuid'] || '';
    }

    get label(): string {
        return this._object['label'] || '';
    }

    get type(): RepositoryType {
        if (!this._object['type'] || !(this._object['type'] in FILTER_REPOSITORY_TYPE)) {
            return RepositoryType.ALM;
        }
        return this._object['type']
    }

    get description(): string {
        return this._object['description'] || '';
    }

    get isSystem(): boolean {
        return this._object['isSystem'];
    }

    get packages(): IPackageProps[] {
        return this._object['packages'] || [];
    }

    get updatedAt(): Date {
        return this._object['updatedAt'] ? new Date(this._object['updatedAt']) : null;
    }

    get createdAt(): Date {
        return this._object['createdAt'] ? new Date(this._object['createdAt']) : null;
    }
}

export interface ICreateRepositoryRequest {
    label: string;
    type?: RepositoryType;
    description?: string;
}

export interface ICreateRepositoryResponse {
    repository: RepositoryDto;
}

export interface IGetRepositoryRequest {
    includePackages?: boolean;
}

export interface IGetRepositoryResponse {
    repositories: RepositoryDto[];
}

export type TUpdateRepositoryRequest = Omit<ICreateRepositoryRequest, 'type' | 'accountUuid'>
export interface IUpdateRepositoryResponse {
    updated: boolean;
}

export interface IDeleteRepositoryResponse {
    deleted: boolean;
}
